import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useDemographics } from "~/sdks/LocalDemographics/context";

import { Chart } from "@local-logic/core/ui";
import type { Variable } from "@local-logic/client";

export const PopulationByAgeGroup = () => {
  const { t } = useTranslation("localDemographics");
  const {
    demographicsState: { population_age: populationAge },
  } = useDemographics();

  const populationAgeFormatted = useMemo(() => {
    if (!populationAge) {
      return null;
    }

    if (populationAge?.variables.length > 12) {
      const keys = populationAge?.variables.map((e) => {
        const labels = e.label.split(" ");
        labels.splice(1, 1);

        return labels;
      });

      const mergedPopulation: {
        variable: string;
        value: number;
        label: string;
      }[] = [];

      keys.forEach((element, index) => {
        if (index === 0 || index % 2 === 0) {
          mergedPopulation.push({
            variable: `age_${element[0]}_${keys[index + 1][1]}`,
            value:
              populationAge.variables[index].value +
              populationAge.variables[index + 1].value,
            label: `${element[0]} to ${keys[index + 1][1]}`,
          });
        }
      });

      return mergedPopulation;
    }

    return populationAge.variables;
  }, [populationAge]);

  const dataset = useMemo(
    () => ({
      labels:
        populationAgeFormatted?.map((variable: Variable) => variable.label) ||
        [],
      data:
        populationAgeFormatted?.map((variable: Variable) =>
          Number((variable.value * 100).toFixed(1)),
        ) || [],
    }),
    [populationAgeFormatted],
  );

  const chartOptions = useMemo(
    () => ({
      title: t("data.population.graphs.populationByAgeGroup.title"),
      labels: dataset.labels,
      data: dataset.data,
      unit: "%",
    }),
    [dataset],
  );

  return (
    <Chart.Root {...chartOptions}>
      <Chart.BarChart />
    </Chart.Root>
  );
};
